import { AppHelpers } from "@ai360/core";
import { AllReports } from "./all-reports";
import { ReportReportBooks } from "~/report-books/report-report-books";

const ReportsViewResolver = (childNameCode) => {
    if (AppHelpers.isNothing(childNameCode)) {
        return;
    }
    switch (childNameCode) {
        case "105": // Default reports view
            return {
                component: AllReports,
                halfScreen: true,
            };
        case "427": //report books
            if (AppHelpers.isNothing(childNameCode)) {
                throw new Error("Report Books View is not defined.");
            }
            return {
                component: ReportReportBooks,
                halfScreen: true,
            };
        default:
            throw new Error(`Unknown Report child ${childNameCode}`);
    }
};
export default ReportsViewResolver;
